import { pricesToObject } from './pricesToObject';
import { addDefaulAndFacetArrayToObject } from './addDefaulAndFacetArrayToObject';
import { arrayToObject } from './arrayToObject';
import { facetToBoolean } from './facets';

export const getFiltersValuesJobs = (filters, filtersConf, facets, country, intl) => ({
  ...filters,
  salary_min: pricesToObject(filtersConf.salaries, intl, country),
  salary_max: pricesToObject(filtersConf.salaries, intl, country),
  category: addDefaulAndFacetArrayToObject(facets.ad_category, intl),
  company: addDefaulAndFacetArrayToObject(facets.fa_company, intl),
  job_type: addDefaulAndFacetArrayToObject(facets.fa_contract, intl),
  working_hours: addDefaulAndFacetArrayToObject(facets.fa_working_hours, intl),
  experience_min: arrayToObject([1, 2, 3, 4, 5]),
  telecommute: facetToBoolean(facets.telecommute),
});



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/getFiltersValuesJobs.js